export default "__VITE_ASSET__lLNsCnNP__"